import React from "react";
import PropTypes from "prop-types";
import ReactEchartsCore from "echarts-for-react/lib/core";
import echarts from "echarts/lib/echarts";
import "echarts/lib/component/title";

import "echarts/lib/chart/bar";

import NHFetch from "../../utils/NHFetch.js";
import numeral from 'numeral';

const yxxtBasicUrl = "api/zhxg-yxxt"; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 60 * 1000; //轮询时间间隔

/**
 * * 校区报到率环形图
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            barData: [], //各校区报到率
            panelData: {}, //总报到率
            zs: 0,
            bl: 0,
        };

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 环节专业新生人数数据
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + "/sstj/getRateOfCampusReported", "GET")
          .then((res) => {
              if (res && res.data) {
                  // 格式化，保留两位小数
                  let data = res.data.map(item => {
                      let ret = {};
                      ret.bdl = item.bdl ?
                        (item.bdl === 0 || item.bdl === 1) ?
                          item.bdl
                          : item.bdl.toFixed(4)
                        : 0;
                      ret.pm = item.pm;
                      ret.xqmc = item.xqmc;
                      ret.bdrs = item.bdrs;
                      return ret;
                  })
                  this.setState({errCount: 0, barData: data});
              }
          })
          .catch((err) => {
              let errCount = this.state.errCount;
              //如果请求异常次数未超过最大次数限制，则继续尝试
              if (errCount < errMaxCount) {
                  this.polling = setTimeout(() => {
                      this.getData();
                  }, speed);
                  this.setState({errCount: errCount + 1});
              } else {
                  //异常超过3次后终止轮询
                  if (this.polling) {
                      clearTimeout(this.polling);
                  }
              }
          });

        NHFetch(yxxtBasicUrl + "/sstj/getStatisticsForReported", "GET")
          .then((res) => {
              if (res && res.data) {
                  this.polling = setTimeout(() => {
                      this.getData();
                  }, speed);
                  this.setState({errCount: 0, panelData: res.data});
              }
          })
          .catch((err) => {
              let errCount = this.state.errCount;
              //如果请求异常次数未超过最大次数限制，则继续尝试
              if (errCount < errMaxCount) {
                  this.polling = setTimeout(() => {
                      this.getData();
                  }, speed);
                  this.setState({errCount: errCount + 1});
              } else {
                  //异常超过3次后终止轮询
                  if (this.polling) {
                      clearTimeout(this.polling);
                  }
              }
          });
    };

    /**
     * * 构造条形统计图
     * @memberof Home
     */
    getBarOption = () => {
        const {panelData, barData} = this.state;
        const {rem} = this.props;

        let angleAxisData = barData.map(item => {
          return item.xqmc ? item.xqmc : '';
      });
  
      let AseriesData = barData.map(item => {
          return item.bdrs ? item.bdrs : 0;
      });
  
      //环节办理率
      let BseriesData = barData.map(item => {
          return item.bdrs+"/"+(item.bdl*100).toFixed(2);
      });

      let zrs = panelData.zrs;
      let zbdrs = panelData.zbdrs;

        let pieTitleText = '0%';

        if (zrs !== 0) {
            let p = zbdrs / zrs * 100;
            if (p === 0 || p === 100) {
                pieTitleText = `${p}%`;
            } else {
                pieTitleText = `${p.toFixed(2)}%`;
            }
        }
        let zbdl = pieTitleText;

        const option = {
            title: [
                {
                    text: "全校总报到率：",
                    top: 2,
                    left: "50%",
                    textStyle: {
                        color: "white",
                        fontSize: 15,
                    },
                },
                {
                    text: zbdl,
                    left: "80%",
                    textStyle: {
                        color: "#00ffca",
                        fontSize: 20,
                    },
                },
                {
                    text: "各校区报到率",
                    top: 2,
                    textStyle: {
                        color: "#05ffe3",
                        fontSize: 0.18 * rem,
                        fontWeight: 100,
                    },
                },
            ],
            grid: {
              left: '0%',
              right: '4%',
              bottom: '3%',
              containLabel: true
          },
          xAxis: [
              {
                  show: true,
                  inverse: true,
                  data: angleAxisData,
                  axisLine: {
                      show: false
                  },
                  axisTick: {
                      show: false
                  },
                  axisLabel: {
                      color: '#fce412',
                      textStyle: {
                          fontSize:'100%',
                          lineHeight: '70',
                      },
                      formatter: function(params) {
                          var newParamsName = ''
                          var paramsNameNumber = params.length
                          var provideNumber = 6;
                          var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                          for (let row = 0; row < rowNumber;row++) {
                            newParamsName +=
                              params.substring(
                                row * provideNumber,
                                (row + 1) * provideNumber
                              ) + '\n'
                          }
                          return newParamsName;
                      }
                  }
              },
              {
                  show: true,
                  inverse: true,
                  data: BseriesData,
                  axisLine: {
                      show: false
                  },
                  axisLabel: {
                     // formatter: '{value} %',
                      formatter: function (val) {
                        return val.split("/")[0]+"人"+"\n"+val.split("/")[1]+"%"
                    },
                      textStyle: {
                          fontSize: 0.14 * rem,
                          color: '#00ffca'
                      }
                  },
                  axisTick: {
                      show: false
                  },
                  splitLine: {
                      show: false
                  }
              }
          ],
          yAxis: {
              type: 'value',
              axisLine: {
                  show: false
              },
              axisTick: {
                  show: false
              },
              axisLabel: {
                  show: false
              },
              splitLine: {
                  show: false
              },
          },
          legend: {
              show: false,
              data: ['已办理', '未办理']
          },
          series: [
              {
                  type: 'bar',
                  data: AseriesData,
                  name: '已办理',
                  barMaxWidth: 0.24 * rem,
                  barMinHeight: 1,
                  itemStyle: {
                      normal: {
                          barBorderRadius: 0.05 * rem,
                          color: {
                              type: 'linear',
                              x: 0,
                              y: 1,
                              colorStops: [
                                  {
                                      offset: 0,
                                      color: '#fce412'   // 0% 处的颜色
                                  },
                                  {
                                      offset: 1,
                                      color: '#00ffca'// 100% 处的颜色
                                  }
                              ],
                              globalCoord: false // 缺省为 false
                          }
                      }
                  }
              }
          ],
        };
        return option;
    };

    render() {
        return (
          <div style={{width: "100%", height: "100%"}}>
              <ReactEchartsCore
                style={{width: "100%", height: "100%"}}
                echarts={echarts}
                option={this.getBarOption()}
                notMerge={true}
                lazyUpdate={true}
              />
          </div>
        );
    }
}

IndexComponent.defaultProps = {};

IndexComponent.propTypes = {
    rem: PropTypes.number,
};

export default IndexComponent;



// WEBPACK FOOTER //
// ./containers/Show-gdnh/_RightTopBox.js